// Import required libraies
import React, { useEffect, useState } from "react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import TextField from "@mui/material/TextField";
import Chip from "@mui/material/Chip";
import { createFilterOptions } from "@mui/material/Autocomplete";
import { Box, Checkbox, Paper } from "@mui/material";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import ClearIcon from "@mui/icons-material/Clear";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

// * Import data
import { useTheme } from "@emotion/react";

// * Import 3rd party
import Autocomplete from "@mui/material/Autocomplete";
import { styled } from "@mui/material/styles";
import { LightTooltip } from "../../../../kit/LightToolTip";
import { fetchOwnersData, fetchOwnersData2 } from "../../../../services/api";

const numberOfChips = (moreChipsFlag) => {
  const width = window.innerWidth;
  if (moreChipsFlag) {
    return 5;
  }
  if (width < 1100) {
    return 1;
  } else if (width < 1273) {
    return 2;
  } else if (width >= 1273 && width < 1565) {
    return 2;
  } else {
    return 3;
  }
};

const StyledAutoComplete = styled(
  Autocomplete,
  {}
)(({ theme, customProps }) => ({
  // height: "2em !important",
  // width: "100%",
  // borderRadius: theme.size[4],
  "& .MuiFilledInput-root-notchedOutline": {
    borderColor: "transparent !important",
  },
  "& .MuiFilledInput-root": {
    height: theme.size[50],
    backgroundColor: theme.palette.form.fieldBackground,
    paddingTop: "0px",
    fontSize: theme.size[13],
    color: theme.palette.form.text,
    borderBottom: "0px !important",
    "&:before, &:after": {
      borderBottom: "0px !important",
    },
  },
  "& .Mui-disabled": {
    backgroundColor: `${theme.palette.rapidInfra.disabledGrey2} !important`,
  },
}));

const ChipCard = ({ value, theme }) => {
  return (
    <Box
      sx={{
        backgroundColor: theme.palette.rapid.lightGrey,
        color: theme.palette.rapidInfra.text,
        fontSize: theme.size[12],
        fontWeight: theme.fontWeight[500],
        padding: theme.size[8],
        borderRadius: theme.size[4],
        marginRight: theme.size[8],
      }}
    >
      {value}
    </Box>
  );
};
// # COMPONENT
const MultiSelectDropDown = ({
  label,
  type,
  value,
  placeholder,
  prefix,
  options,
  info,
  isRequired = false,
  isDisabled = false,
  componentId,
  categoryId,
  isOktaUserEnabled = false,
  loggedInUserEmail,
  disableInputSelection = false,
  onChange = () => {},
}) => {
  const theme = useTheme();
  const filter = createFilterOptions();
  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" />;

  // # JSX
  return (
    <>
      {prefix !== "" && (
        <span
          style={{
            fontSize: theme.size[12],
            fontWeight: theme.fontWeight[500],
            marginRight: theme.size[8],
            color: theme.palette.rapidInfra.text,
          }}
        >
          {prefix}
        </span>
      )}
      <div
        style={{
          fontSize: theme.size[12],
          fontWeight: theme.fontWeight[500],
          color: theme.palette.rapidInfra.text,
          marginBottom: theme.size[8],
        }}
      >
        {label}

        {isRequired && <span style={{ color: "red", marginLeft: 5 }}>*</span>}
        {info && (
          <LightTooltip
            title={info}
            placement="top"
            arrow
            sx={{
              "& .MuiTooltip-tooltip": {
                padding: "8px 12px", // Adjust padding if needed
              },
            }}
          >
            <InfoOutlinedIcon
              style={{
                fontSize: theme.size[14],
                color: theme.palette.rapidInfra.infoIcon,
                marginLeft: 5,
                cursor: "pointer",
              }}
            />
          </LightTooltip>
        )}
      </div>
      {disableInputSelection ? (
        <div
          style={{
            display: "flex",
          }}
        >
          {label === "Approvers List"
            ? options.map((option, index) => {
                return <ChipCard key={index} value={option} theme={theme} />;
              })
            : value.map((option, index) => {
                return <ChipCard key={index} value={option} theme={theme} />;
              })}
        </div>
      ) : (
        <>
          <StyledAutoComplete
            multiple
            id="tags-filled"
            options={options}
            value={value}
            disabled={isDisabled}
            isOptionEqualToValue={(option, value) =>
              option === value || value === ""
            }
            freeSolo={false}
            disableCloseOnSelect
            renderTags={(value, getTagProps) => {
              const numberOfChip = 3;
              return (
                <>
                  {value.slice(0, numberOfChip).map((option, index) => (
                    <Chip
                      variant="outlined"
                      label={option}
                      title={option}
                      deleteIcon={
                        <ClearIcon
                          sx={{
                            color: `${theme.palette.form.text} !important`,
                            fontSize: `${theme.size[15]} !important`,
                          }}
                        />
                      }
                      {...getTagProps({ index })}
                      style={{
                        color: theme.palette.form.text,
                        borderRadius: theme.size[4],
                        borderColor: theme.palette.secondary.main,
                        maxWidth: theme.size[120],
                        width: value.length > 1 ? theme.size[70] : "auto",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        padding: theme.size[0],
                        height: theme.size[25],
                      }}
                    />
                  ))}
                  {value.length > numberOfChip &&
                    `+${value.length - numberOfChip} more`}
                </>
              );
            }}
            PaperComponent={({ children }) => (
              <Paper
                style={{ backgroundColor: theme.palette.form.fieldBackground }}
              >
                {children}
              </Paper>
            )}
            renderOption={(props, option, { selected }) => {
              return (
                <li
                  {...props}
                  style={{
                    color: theme.palette.form.text,
                    fontSize: theme.size[13],
                    height: theme.size[40],
                  }}
                >
                  <Checkbox
                    icon={icon}
                    checkedIcon={checkedIcon}
                    style={{
                      marginRight: 8,
                      color: theme.palette.secondary.main,
                    }}
                    checked={selected}
                  />
                  {label === "Gen AI options" ? (
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <span>{option}</span>
                      <span>
                        <span
                          style={{
                            color: theme.palette.primary.main,
                            fontWeight: theme.fontWeight[500],
                            marginRight: theme.size[4],
                          }}
                        >
                          Supported:
                        </span>
                        <span
                          style={{
                            fontSize: theme.size[12],
                            fontWeight: theme.fontWeight[400],
                          }}
                        >
                          {option === "GPT 4"
                            ? "Text, Image (Beta)"
                            : option === "GPT 4.o"
                            ? "Text, Audio, Image"
                            : "Text"}
                        </span>
                      </span>
                    </div>
                  ) : (
                    option
                  )}
                </li>
              );
            }}
            filterOptions={(options, params) => {
              const filtered = filter(options, params);
              return filtered;
            }}
            PopperProps={{
              disablePortal: true,
            }}
            popupIcon={<KeyboardArrowDownIcon />}
            sx={{
              "& .MuiAutocomplete-popupIndicator": {
                color: theme.palette.icons.main,
                opacity: 0.5,
              },
              "&:hover": {
                backgroundColor: "none",
              },
            }}
            disableClearable
            getOptionLabel={(option) => option}
            onChange={(e, value) => {
              const validArray = value
                .filter((elem) => typeof elem !== "object")
                .map((elem) => elem?.trim())
                .filter((elem) => elem !== "");

              onChange(categoryId, componentId, validArray);
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="filled"
                placeholder={placeholder}
                margin="normal"
                fullWidth
                sx={{
                  marginTop: 0,
                  marginBottom: 0,
                  height: "2em !important",
                }}
              />
            )}
            noOptionsText={
              <div
                style={{
                  color: theme.palette.form.text,
                  fontSize: theme.size[13],
                }}
              >
                {"No Option Found"}
              </div>
            }
          />
        </>
      )}
    </>
  );
};

// # EXPORTS
export default MultiSelectDropDown;
